// extracted by mini-css-extract-plugin
export var swiper = "career-module--swiper--1HgS9";
export var careerBackground = "career-module--career-background--1HowU";
export var dimmed = "career-module--dimmed--3vtIf";
export var slideContent = "career-module--slide-content--11CxM";
export var slideTitle = "career-module--slide-title--2tYml";
export var slideSummary = "career-module--slide-summary--1K8ml";
export var slideLink = "career-module--slide-link--3Q2SO";
export var slideSummaryEng = "career-module--slide-summary-eng--1Mt4s";